// Lib
import React from 'react';
import { cx } from '@milanote/roma/utils/cx';
import { ChevronLeft, ChevronRight, LinkExternal01, Download01, Pencil02, Crop02 } from '@untitledui/icons';

type ImageModalV2PrimaryToolsProps = {
    isEditable: boolean;
    showDownloadOption: boolean;
    isPresentationMode: boolean;
};

const buttonClassName = () =>
    cx(
        'flex items-center justify-center p-2 transition-[background,color] duration-150 ease-in-out border-0 rounded-md bg-transparent text-[var(--palette-white-opacity-85)] cursor-pointer',
        'hover:bg-[var(--palette-white-opacity-10)] hover:text-[var(--palette-white)]',
    );

const ImageModalV2PrimaryTools: React.FC<ImageModalV2PrimaryToolsProps> = ({
    isEditable,
    showDownloadOption,
    isPresentationMode,
}) => {
    return (
        <div className="ImageModalV2PrimaryTools flex items-center justify-center gap-0.5">
            <button
                type="button"
                className={cx('ImageModalV2PrimaryTools-button nav', buttonClassName())}
                title="Previous image"
            >
                <ChevronLeft size={20} />
            </button>
            <button
                type="button"
                className={cx('ImageModalV2PrimaryTools-button nav', buttonClassName())}
                title="Next image"
            >
                <ChevronRight size={20} />
            </button>

            <div className="ImageModalV2PrimaryTools-divider mx-1.5 h-5 w-px bg-[var(--palette-white-opacity-20)]" />

            <button type="button" className={cx('ImageModalV2PrimaryTools-button', buttonClassName())} title="New tab">
                <LinkExternal01 size={18} />
            </button>

            {showDownloadOption && !isPresentationMode && (
                <button
                    type="button"
                    className={cx('ImageModalV2PrimaryTools-button', buttonClassName())}
                    title="Download"
                >
                    <Download01 size={18} />
                </button>
            )}

            {isEditable && (
                <button type="button" className={cx('ImageModalV2PrimaryTools-button', buttonClassName())} title="Draw">
                    <Pencil02 size={18} />
                </button>
            )}

            {isEditable && !isPresentationMode && (
                <button type="button" className={cx('ImageModalV2PrimaryTools-button', buttonClassName())} title="Crop">
                    <Crop02 size={18} />
                </button>
            )}
        </div>
    );
};

export default ImageModalV2PrimaryTools;
